export default __webpack_public_path__ + "static/raf-banner-5ec41e975488625b92997c4b0305cabe.png";